
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form7";
const form7State = namespace("Form7");

import Form7ProcessHeader from "@/components/process/Form7/components/Form7ProcessHeader.vue";
import Form7 from "@/components/process/Form7/components/pdf/Form7.vue"

import { form7StatusInfoType } from '@/types/Information/Form7';

@Component({
    components:{
        Form7ProcessHeader,
        Form7
    }
})
export default class PreviewForm7 extends Vue {

    @form7State.State
    public currentNoticeOfUrgentApplicationId: string;

    stepsCompleted = {} as form7StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form7"}); 
    }
}
